import React from 'react';
import ReactDOM from 'react-dom';
import AuthWrapper from './components/AuthWrapper';
import * as serviceWorker from './serviceWorker';

import 'semantic-ui-css/semantic.min.css';
import { loadProgressBar } from 'axios-progress-bar'
import 'axios-progress-bar/dist/nprogress.css'

import './i18n';

//Works just for API calls it seems (Based on axios), not for Apollo ones
loadProgressBar();

ReactDOM.render(<AuthWrapper/>, document.getElementById('root')
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
